import { NgModule } from '@angular/core';

import { UpdateModalComponent } from './update-modal.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [CommonModule, TranslateModule],
    exports: [UpdateModalComponent],
    declarations: [UpdateModalComponent],
})
export class UpdateModalModule {}
